import {styled} from "@mui/system";
import {Switch} from "@mui/material";

 const SwitchButton = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
            },
        }
    },
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: 'white',
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));

export default SwitchButton;
